import { useLingui } from "@lingui/react/macro";
import { ArrowDown } from "lucide-react";
import type { Ref } from "react";

export function JumpToLatestButton({
  atEnd,
  onClick,
  ref,
}: {
  atEnd: boolean;
  onClick: () => void;
  ref?: Ref<HTMLButtonElement>;
}) {
  const { t } = useLingui();
  return (
    <button
      ref={ref}
      type="button"
      data-testid="jump-to-latest"
      aria-label={t`Jump to latest`}
      aria-hidden={atEnd}
      tabIndex={atEnd ? -1 : 0}
      onClick={onClick}
      className={`absolute end-3 bottom-4 z-20 grid h-9 w-9 place-items-center md:end-7 rounded-full border border-border bg-muted/95 text-foreground/75 shadow-md backdrop-blur transition-[opacity,transform,background-color] duration-200 ease-[cubic-bezier(.22,1,.36,1)] hover:bg-border motion-reduce:transition-none ${
        atEnd ? "pointer-events-none translate-y-2 opacity-0" : "translate-y-0 opacity-100"
      }`}
    >
      <ArrowDown size={17} strokeWidth={1.8} />
    </button>
  );
}
